import DashboardAdministrador from "./DashboardAdministrador";
import DashboardAlunoOmni from "./DashboardAlunoOmni";
import DashboardAlunoOmniConfigure from "./DashboardAlunoOmni/configure";
import DashboardProfessorAlagoas from "./DashboardProfessorAlagoas";
import DashboardTrailStudent from "./DashboardTrailStudent";
import LegacyProfessorDashboard from "./LegacyProfessorDashboard";
import LegacyStudentDashboard from "./LegacyStudentDashboard";
import NewProfessorDashboard from "./NewProfessorDashboard";
import NewStudentDashboard from "./NewStudentDashboard";
import imgAdministrador from "../../assets/dashboards/administrador.png";
import imgAluno from "../../assets/dashboards/aluno.png";
import imgOmni from "../../assets/dashboards/omni.png";
import imgProfessor from "../../assets/dashboards/professor.png";

export const dashboards = [
  {
    name: "DashboardProfessor",
    // name: "LegacyProfessorDashboard",
    component: LegacyProfessorDashboard,
    roleTypes: ["P"],
    image: imgProfessor,
    configComponent: null
  },
  {
    name: "DashboardAluno",
    // name: "LegacyStudentDashboard",
    component: LegacyStudentDashboard,
    roleTypes: ["A", "S", "V"],
    image: imgAluno,
    configComponent: null
  },
  {
    name: "DashboardAdministrador",
    component: DashboardAdministrador,
    roleTypes: ["G", "U", "R", "E"],
    image: imgAdministrador,
    configComponent: null
  },
  {
    name: "DashboardAlunoOmni",
    component: DashboardAlunoOmni,
    roleTypes: ["P", "A", "S", "V"],
    image: imgOmni,
    configComponent: DashboardAlunoOmniConfigure
  },
  {
    name: "DashboardProfessorAlagoas",
    component: DashboardProfessorAlagoas,
    roleTypes: ["P", "E", "R", "U"],
    image: null,
    configComponent: null
  },
  {
    name: "DashboardTrailStudent",
    component: DashboardTrailStudent,
    roleTypes: ["A"],
    image: null,
    configComponent: null
  },
  {
    name: "DashboardAlunoPaulista",
    // name: "NewStudentDashboard",
    component: NewStudentDashboard,
    roleTypes: ["A"],
    image: imgAluno,
    configComponent: null
  },
  {
    name: "NewProfessorDashboard",
    component: NewProfessorDashboard,
    roleTypes: ["P"],
    image: imgProfessor,
    configComponent: null
  }
];

export const defaultDashboards = {
  G: "DashboardAdministrador",
  U: "DashboardAdministrador",
  R: "DashboardAdministrador",
  E: "DashboardAdministrador",
  P: "DashboardProfessor",
  // P: "NewProfessorDashboard",
  A: "DashboardAluno",
  // A: "NewStudentDashboard",
  S: "DashboardAluno",
  // S: "NewStudentDashboard",
  V: "DashboardAluno"
  // V: "NewStudentDashboard"
};
